const root = 'importList-importListProduct'
const variantRow = `${root}-variantRow`

export const TestId = {
  optionNameInput: `${root}-optionNameInput`,
  variantRow,
  variantImage: `${variantRow}-image`,
  variantSkuField: `${variantRow}-skuField`,
  variantOptionField: `${variantRow}-optionField`,
  variantAddToStoreSwitch: `${variantRow}-addToStoreSwitch`,
}
